import _ from 'lodash';


export const getScheduleGroups = (schedule) => {
    const groupsList = {}
    const scheduleArr = _.toArray(schedule)
    for (const day of scheduleArr) {
        const dayArr = _.toArray(day)
        for (const lesson of dayArr) {
            lesson.forEach(item => {
                const {group_id, groupname} = item[0]
                groupsList[group_id] = groupname
            })
        }
    }
    return groupsList
}